/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
import { Checkbox, message, Modal } from 'antd';
import React, { useState } from 'react';
import { CourseType, TermSettingType, EventType, TermType } from 'types/course.type';
import fa from 'locales/fa.json';
import AntButton from 'components/Common/AntButton';
import { consultingRules, faNumber } from 'utils/common.util';
import request from 'services/request';
import { DirectPayUrl, discountUrl } from 'services/routes';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getUserAction } from 'store/account/account.action';
import ChargeWallet from 'components/Common/ChargeWallet';
import Cookies from 'js-cookie';

type ModalType = {
  isVisible: boolean;
  setIsVisible: (status) => void;
  setTryRegister: (status) => void;
  data:
    | CourseType
    | EventType
    | TermType
    | { price: number; registered: boolean; id: string; title: string; discount: number }
    | any; // eslint-disable-line
  termData?: TermSettingType;
};
const RegisterModal: React.FC<ModalType> = (props) => {
  const { isVisible, setIsVisible, data, termData, setTryRegister } = props;
  const id = data?.id;
  const dispatch = useDispatch();
  const router = useRouter();
  const { step4 } = fa.term.register;
  const [discounts, setDiscounts] = useState(['wallet']);
  const user = useSelector((state) => state.account.user);
  const { eventId, termId, examId } = router.query;
  const [code, setCode] = useState('');
  const type = eventId ? 'event' : examId ? 'exam' : termId ? 'term' : 'workshop';
  const [loading, setLoading] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [openChargeModal, setOpenChargeModal] = useState(false);
  const [acceptCondition, setAcceptCondition] = useState(false);
  const [openConditionModal, setOpenConditionModal] = useState(false);
  const isAdvisor = data?.url?.includes('counseling');

  const firstPrice = data?.price;
  const discount = discountPrice
    ? firstPrice - Number(discountPrice)
    : data?.discount
    ? (firstPrice * data?.discount) / 100
    : 0;
  const priceAfterDiscount = firstPrice - discount;

  const reduceScore = discounts.includes('score')
    ? user.score_value > priceAfterDiscount
      ? priceAfterDiscount
      : user.score_value
    : 0;

  const priceAfterScore = priceAfterDiscount - reduceScore;
  const reduceWallet = isAdvisor
    ? 0
    : discounts.includes('wallet')
    ? user?.price > priceAfterScore
      ? priceAfterScore
      : user?.price
    : 0;

  const totalPrice = priceAfterScore - reduceWallet;

  const handleDiscount = async (): Promise<void> => {
    const body = { code, for: type, id_for: id }; // eslint-disable-line
    setLoading('discount');
    const res: any = await request.post(discountUrl(), body); // eslint-disable-line
    setLoading(null);
    res.data.code ? message.success(res.data.msg) : message.warn(res.data.msg);
    res.data.code && setDiscountPrice(Number(res.data.price));
  };

  const handlePay = async (): Promise<void> => {
    const refId = Cookies.get('taalei-ref');
    const href = data.url || DirectPayUrl(id, type);

    let body: any = { code, useWallet: discounts.includes('wallet'), refId }; // eslint-disable-line
    body = data.body
      ? data.body
      : termData
      ? { ...body, term_type: termData.term_type } // eslint-disable-line
      : body;
    setLoading('pay');
    const res: any = await request.post(href, body); // eslint-disable-line
    setLoading(null);
    if (!res.ok) return;
    if (!res.data.link) {
      !!data?.action && data.action();
      message.success(res.data.message);
      dispatch(getUserAction());
      setIsVisible(false);
      setTryRegister(false);
      router.replace(router.asPath);
    } else window.location.assign(res.data.link);
  };

  return (
    <Modal
      title={null}
      footer={null}
      width={600}
      destroyOnClose
      open={isVisible}
      onCancel={(): void => (
        setIsVisible(''), setDiscountPrice(null), setTryRegister(false)
      )}
    >
      <div className="center flex-col ">
        <div className="font-bold text-[24px] border-b border-b-gray-1 w-full text-center pb-[15px]">
          {data?.title} {termData ? `(${termData.name})` : ''}
        </div>

        <div className="my-[20px] flex w-full">
          <input
            className="border min-w-0 flex-1 border-gray-1 text-[18px] toRight p-[5px] ml-[12px] focus:border-gray-2 rounded-[6px]"
            onChange={(e): void => setCode(e.target.value)}
            placeholder={fa.global.discount}
            value={code}
            type="text"
          />
          <AntButton
            width="120px"
            height="40px"
            fontSize={18}
            loading={loading === 'discount'}
            onClick={handleDiscount}
            disabled={!code.length}
          >
            {fa.global.apply}
          </AntButton>
        </div>

        <div className="border-b w-full border-b-black20 py-[18px]">
          {!isAdvisor && (
            <Checkbox
              checked={discounts.includes('wallet')}
              className="flex-1 w-full"
              onChange={(e): void => {
                setDiscounts(
                  e.target.checked
                    ? [...discounts, 'wallet']
                    : discounts.filter((k) => k !== 'wallet'),
                );
              }}
            >
              <div className="text-[16px] font-bold">{step4.payWallet}</div>
            </Checkbox>
          )}
          <div className="mt-[10px] mr-[24px] items-center flex justify-between">
            <div className="text-[14px]">{step4.walletAmount}</div>
            <div className="px-[12px] py-[4px] font-bold text-green90 flex gap-[6px] bg-green10 rounded-full">
              {faNumber(Number(user?.price).toLocaleString())} {fa.global.simpleTooman}
            </div>
          </div>
        </div>

        <div className="font-bold w-full flex pt-[18px] justify-between text-[16px] items-center">
          <div>{step4[isAdvisor ? 'consultingAmount' : 'payAmount']}</div>
          <div>
            {faNumber(firstPrice?.toLocaleString())} {fa.global.simpleTooman}
          </div>
        </div>

        <div className="flex w-full pt-[18px] justify-between text-[14px] items-center">
          <div>
            {step4.userDiscount} (
            {faNumber(Math.round((discount / firstPrice) * 100) || data?.discount)}%)
          </div>

          <div>
            {faNumber(discount.toLocaleString())} {fa.global.simpleTooman}
          </div>
        </div>

        {/* <div className="flex w-full pt-[18px] justify-between text-[14px] items-center">
          <div>{step4.payHasane}</div>
          <div>
            {faNumber(reduceScore.toLocaleString())} {fa.global.simpleTooman}
          </div>
        </div> */}

        {!isAdvisor && (
          <div className="flex w-full pt-[18px] justify-between text-[14px] items-center">
            <div>{step4.payWallet}</div>
            <div>
              {faNumber(reduceWallet?.toLocaleString())} {fa.global.simpleTooman}
            </div>
          </div>
        )}

        <div className="flex w-full pt-[18px] font-bold text-green90 justify-between text-[16px] items-center">
          <div>{step4.price}</div>
          <div>
            {faNumber(totalPrice.toLocaleString())} {fa.global.simpleTooman}
          </div>
        </div>

        {isAdvisor && (
          <div className="w-full">
            <div className="text-center">
              <div className="mt-[20px] text-red80">
                پراخت تنها از طریق کیف پول امکان پذیر است
              </div>
              <div
                className={`${
                  totalPrice > user?.price ? 'text-[18px]' : 'text-[14px]'
                }  mt-[4px]`}
              >
                برای شارژ کیف پول{' '}
                <a onClick={(): void => setOpenChargeModal(true)}>اینجا</a> کلیک کنید.
              </div>
            </div>
            <div className="mt-[20px] flex w-fit items-center">
              <Checkbox
                checked={acceptCondition}
                className="flex-1 w-full"
                onChange={(e): void => {
                  setAcceptCondition(e.target.checked);
                }}
              >
                <div className="text-[16px] w-fit">کلیه مفاد آیین نامه را میپذیرم.</div>
              </Checkbox>

              <div
                onClick={(): void => setOpenConditionModal(true)}
                className="text-[12px] mt-[6px] link"
              >
                (مشاهده آیین نامه)
              </div>

              <Modal
                footer={null}
                open={openConditionModal}
                onCancel={(): void => setOpenConditionModal(false)}
              >
                {consultingRules(!!data?.body?.skill_id)
                  .split('\n')
                  .map((item, index) => (
                    <p key={index}>{item}</p>
                  ))}
              </Modal>
            </div>
          </div>
        )}

        <div className="flex w-full flex-col xl:flex-row gap-[8px] mt-[18px]">
          <div className="bg-yellow20 border text-[16px] py-[16px]  border-yellow50 center rounded-[12px] flex-1">
            {totalPrice !== firstPrice && (
              <s className="font-bold text-light mr-[8px] ml-[8px]">
                {faNumber(firstPrice?.toLocaleString())} {fa.global.simpleTooman}
              </s>
            )}
            <span className="font-bold text-green80 mr-[8px]">
              {faNumber(totalPrice?.toLocaleString())} {fa.global.simpleTooman}
            </span>
          </div>

          <button
            disabled={isAdvisor && !acceptCondition}
            onClick={handlePay}
            className="flex-1 bg-indigo80 disabled:bg-gray-5 text-white rounded-[12px] text-[18px] font-bold py-[16px]"
          >
            {step4.pay}
          </button>
        </div>
      </div>

      <ChargeWallet
        setOpen={setOpenChargeModal}
        open={openChargeModal}
        body={data?.body?.title ? data?.body : null}
      />
    </Modal>
  );
};

export default RegisterModal;
